/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { TourFilter } from '@construction-sites/models/tour-filter';
import { ConstructionSite, Tour } from '@shared/models';

export interface ConstructionSitesState {
  isActionPending: boolean;
  constructionSites: ConstructionSite[];
  currentConstructionSite?: ConstructionSite;
  tourFilter?: TourFilter;
  tours: Tour[];
  actionPending: any;
}

export const initialState: ConstructionSitesState = {
  isActionPending: false,
  constructionSites: [],
  tours: [],
  currentConstructionSite: {} as ConstructionSite,
  actionPending: false
};
